import React from 'react';
import i18next from 'i18next';
import CollapsibleCard from '../../common/CollapsibleCard';

import './ReservationsCalendarCustomEvents.scss';

/* eslint-disable jsx-a11y/anchor-is-valid */
export const ReservationsLegend = () => {
  return (
    <CollapsibleCard
      buttonClassName={'p-1'}
      className={'no-print'}
      title={i18next.t('reservations-legend.title')}
    >
      <div
        style={{
          display: 'flex',
          flexFlow: 'column nowrap',
          gap: 10,
        }}
      >
        <a
          href="#"
          className="fc-event fc-event-start fc-event-end fc-event-today fc-daygrid-event fc-daygrid-dot-event fc-event-count-status"
        >
          <div className="fc-event-main-inner">
            <div className="fc-event-title">
              {i18next.t('reservations-legend.note-example')}
            </div>
          </div>
        </a>

        <a
          href="#"
          className="fc-event fc-event-start fc-event-end fc-event-future fc-daygrid-event fc-daygrid-dot-event"
        >
          <div className="fc-event-main-inner align-vertical">
            <div className="fc-event-title">
              {i18next.t('reservations-legend.regular-reservation')}
            </div>
          </div>
        </a>

        <a
          href="#"
          className="fc-event fc-event-start fc-event-end fc-event-past fc-daygrid-event fc-daygrid-dot-event"
        >
          <div className="fc-event-main-inner align-vertical">
            <span className="event-label event-label--notes-from-customer">!</span>
            <div className="fc-event-title">
              {i18next.t('reservations-legend.reservation-with-guest-note')}
            </div>
          </div>
        </a>

        <a
          href="#"
          className="fc-event fc-event-start fc-event-end fc-event-past fc-daygrid-event fc-daygrid-dot-event"
        >
          <div className="fc-event-main-inner align-vertical">
            <span className="event-label event-label--notes-from-restaurant">!</span>
            <div className="fc-event-title">
              {i18next.t('reservations-legend.reservation-with-restaurant-note')}
            </div>
          </div>
        </a>

        <a
          href="#"
          className="fc-event fc-event-start fc-event-end fc-event-future fc-daygrid-event fc-daygrid-dot-event"
        >
          <div className="fc-event-main-inner align-vertical">
            <span className="event-label event-label--automatic"></span>
            <div className="fc-event-title">
              {i18next.t('reservations-legend.automatic-reservation')}
            </div>
          </div>
        </a>

        <a
          href="#"
          className="fc-event fc-event-start fc-event-end fc-event-past fc-daygrid-event fc-daygrid-dot-event"
        >
          <div className="fc-event-main-inner align-vertical">
            <span className="event-label event-label--file">{i18next.t('reservations-legend.file-label')}</span>
            <div className="fc-event-title">
              {i18next.t('reservations-legend.reservation-with-attachment')}
            </div>
          </div>
        </a>

        <a
          href="#"
          className="fc-event fc-event-start fc-event-end fc-event-past fc-daygrid-event fc-daygrid-dot-event fc-event-success"
        >
          <div className="fc-event-main-inner align-vertical">
            <div className="fc-event-title">
              {i18next.t('reservations-legend.reservation-on-site')}
            </div>
          </div>
        </a>

        <a
          href="#"
          className="fc-event fc-event-start fc-event-end fc-event-past fc-daygrid-event fc-daygrid-dot-event fc-event-declined"
        >
          <div className="fc-event-main-inner align-vertical">
            <div className="fc-event-title">
              {i18next.t('reservations-legend.cancelled-reservation')}
            </div>
          </div>
        </a>

        <a
          href="#"
          className="fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-today fc-daygrid-event fc-daygrid-block-event fc-h-event"
        >
          <div className="fc-event-main">
            <div className="fc-event-main-inner align-vertical">
              <div className="fc-event-title">
                {i18next.t('reservations-legend.entire-place-reservation')}
              </div>
            </div>
          </div>
        </a>
      </div>
    </CollapsibleCard>
  );
};
/* eslint-enable jsx-a11y/anchor-is-valid */

export default ReservationsLegend;
